module.exports = __webpack_public_path__ + "static/img/_2.61391c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_2.png
// module id = GT67
// module chunks = 1